export default `
	work {
		...on WorkItem {
			description
			company
			companyUrl
		}
	}
`;
